const CheckIcon = () => {
  return (
    <svg
      width='20'
      height='21'
      viewBox='0 0 20 21'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        opacity='0.3'
        d='M10 20.5C15.5228 20.5 20 16.0228 20 10.5C20 4.97715 15.5228 0.5 10 0.5C4.47715 0.5 0 4.97715 0 10.5C0 16.0228 4.47715 20.5 10 20.5Z'
        fill='#B3E78B'
      />
      <path
        d='M14.769 6.31769C15.1458 5.91393 15.7786 5.89211 16.1823 6.26895C16.5861 6.64578 16.6079 7.27857 16.2311 7.68232L9.23107 15.1823C8.86546 15.574 8.25606 15.608 7.84923 15.2593L4.34923 12.2593C3.9299 11.8998 3.88134 11.2685 4.24076 10.8492C4.60018 10.4299 5.23148 10.3813 5.65081 10.7407L8.42301 13.1169L14.769 6.31769Z'
        fill='white'
      />
    </svg>
  )
}

export { CheckIcon }
